export default {
  evaluation_dashboard: {
    title: 'Panel de control del comprador',
    unit: ' Empresas',
    average: 'Puntaje promedio:',
    point: ' Puntuación',
    answered_label: 'Enviado',
    evaluated_label: 'Evaluado',
    corporate_average: 'Promedio de sus proveedores',
    points_earned_by_companies: 'Distribución de puntaje de sus proveedores',
    year_modal: {
      title: 'Seleccione año',
      label: 'Año',
    },
    response_status_title: 'Distribución del estado de respuestas',
    response_status_rating_nothing: 'Aún no hay respuestas',
    esg_rating_title: 'Distribución de la calificación ESG',
    esg_score_title: 'Distribución de la puntuación ESG',
    category_scores_title: 'Comparar puntuaciones por categoría',
    category_scores_distribution_title: 'Distribución de la puntuación ESG por categoría',
    category_score_data_all_label: 'Promedio ESG de ASUENE',
    esg_scores_by_industry_title: 'Distribución de la puntuación ESG por industrias',
    environment_score_title: 'Distribución del puntaje medioambiental',
    social_score_title: 'Distribución del puntaje social',
    governance_score_title: 'Distribución del puntaje de gobernanza',
    environment_score_subtitle_upper5: '5 mejores puntajes medioambientales',
    environment_score_subtitle_lower5: '5 peores puntajes medioambientales',
    social_score_subtitle_upper5: '5 mejores puntajes sociales',
    social_score_subtitle_lower5: '5 peores puntajes sociales',
    governance_score_subtitle_upper5: '5 mejores puntajes de gobernanza',
    governance_score_subtitle_lower5: '5 peores puntajes de gobernanza',
    // empty_error_message: "",
    common: {
      companies: ' Empresas',
      update_date: 'Fecha de la última actualización',
    },
    registration_rate: {
      title: 'Fecha de registro',
      tip: 'Empresas registradas en ASUENE ESG del total de empresas a evaluar',
    },
    answer_rate: {
      title: 'Tasa de envío',
      tip: 'Empresas que enviaron la encuesta del total de empresas a evaluar',
    },
    days_remaining: {
      title: 'Días hasta el final de la encuesta',
      tip: 'Días restantes hasta la fecha límite establecida.\nSi desea cambiar la fecha límite póngase en contacto con nosotros.',
      days_remaining_before: '',
      days_remaining_after: 'días restantes',
      expired: 'Plazo excedido.',
    },
    answer_transition: {
      title: 'Tasa de envío',
      companies_submitted: 'Empresas que han enviado',
      breakdown: 'Desglose',
      unregistered: 'No registrado',
      total: 'En total',
      number_of_companies: 'Número de empresas',
    },
    answer_list: {
      title: 'Último envío',
      submitted_at: 'Fecha de envío',
    },
  },
}
